/*
 * Backoffice login/vendor bundle.
 */
import "../../backoffice/office/scripts/vendor/jquery-ui/js/jquery-ui.min.js";
import "../../backoffice/office/scripts/vendor/jquery.uniform/jquery.uniform.min.js";
import "../../backoffice/office/scripts/vendor/bootstrap/dist/js/bootstrap.min.js";
import "../../backoffice/office/scripts/vendor/bootstrap-jasny/dist/extend/js/jasny-bootstrap.min.js";
import "../../backoffice/office/scripts/vendor/jquery-autosize/jquery.autosize.min.js";
import "../../backoffice/office/scripts/vendor/moment/min/moment.min.js";
import "../../backoffice/office/scripts/vendor/dropzone/downloads/dropzone.min.js";
import "../../backoffice/office/scripts/vendor/select2/select2.min.js";
